import { NAME as namespace } from './constants';
import reducer, { getJournalSelectionDisplayed } from './reducer';
import QuestionsContainer from './components/QuestionsContainer';
import JournalSelectionContainer from './components/JournalSelectionContainer';
import FilesContainer from './components/FilesContainer';
export var Files = FilesContainer;
export var JournalSelection = JournalSelectionContainer;
export var Questions = QuestionsContainer;
export var selectors = {
  getJournalSelectionDisplayed: getJournalSelectionDisplayed
};
export var serviceDetails = {
  namespace: namespace,
  reducer: reducer
};
export default {
  JournalSelection: JournalSelection,
  Questions: Questions
};